var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPLOAD_FILE_REQUEST, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_ERROR } from '../actions/uploadFile';
var initialState = {
    text: [],
    isLoading: false,
    isError: false,
    err: ''
};
export function uploadFileReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPLOAD_FILE_REQUEST:
            return __assign(__assign({}, state), { isLoading: true, isError: false });
        case UPLOAD_FILE_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, isError: false, text: action.payload.data });
        case UPLOAD_FILE_ERROR:
            return __assign(__assign({}, state), { isLoading: false, isError: true, err: action.payload.stack });
        default:
            return state;
    }
}
;
//# sourceMappingURL=uploadFile.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPLOAD_FILE_REQUEST, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_ERROR } from '../actions/uploadFile';
var initialState = {
    text: [],
    isLoading: false,
    isError: false,
    err: ''
};
export function uploadFileReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPLOAD_FILE_REQUEST:
            return __assign(__assign({}, state), { isLoading: true, isError: false });
        case UPLOAD_FILE_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, isError: false, text: action.payload.data });
        case UPLOAD_FILE_ERROR:
            return __assign(__assign({}, state), { isLoading: false, isError: true, err: action.payload.stack });
        default:
            return state;
    }
}
;
//# sourceMappingURL=uploadFile.js.map